<template>
  <div class="background-div" :class="{'background-transition': transition}" :style="divStyle"></div>
</template>

<script>
export default {
  name: 'AnimatedBackground',
  data: () => ({
    animation: null,
    transition: false,
    index: 0,
    interval: 8000,
    backgrounds: [
      './background/1.jpg',
      './background/2.jpg',
      './background/3.jpg',
      './background/4.jpg',
      './background/5.jpg',
      './background/6.jpg',
      './background/7.jpg',
    ]
  }),
  computed: {
    divStyle() {
      return { 'background-image': `url("${this.backgrounds[this.index]}")` };
    },
  },
  methods: {
    animate () {
      this.animation = setInterval(() => {
        this.transition = true
        setTimeout(() => {
          this.index = (this.index + 1) % this.backgrounds.length
          this.transition = false
        }, 600);
      }, this.interval);
    }
  },
  created () {
    this.animate()
  },
  beforeDestroy () {
    clearInterval(this.animation)
  }
}
</script>

<style scoped>
.background-div {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  background-size: cover;
  background-position: center;
  box-shadow: 0 0 0 500px rgba(45, 45, 48, 0.3) inset;
}

.background-transition {
  opacity: 0;
}
</style>
